// import ComponentInit from './utils/ComponentInit';
import PeopleListing from '4-sections/FilteredListings/PeopleListing/PeopleListing';
import React from 'react';
import ReactDOM from 'react-dom/client';

// Format:
// data-component-name: ComponentFunction
// we shall order these in page load critical first
global.React = React;
global.ReactDOM = ReactDOM;


global.Components = {
    ...(global.Components ? { ...global.Components } : {}),
    PeopleListing,
};
